export const buildKey = ({ family, milkOrBlack, sweetness, strength, special, temperature }) => {
  const parts = [family];
  
  // For kopi/teh, always include all modifiers in order
  if (family === 'kopi' || family === 'teh') {
    parts.push(milkOrBlack || 'default');
    parts.push(sweetness || 'default');
    parts.push(strength || 'default');
    parts.push(special || 'none');
  }
  
  parts.push(temperature || 'hot');
  
  return parts.join(':');
};

export const buildLabel = (key) => {
  const parts = key.split(':');
  const [family, milkOrBlack, sweetness, strength, special, temperature] = parts;
  
  // Handle non-kopi/teh drinks
  if (family !== 'kopi' && family !== 'teh') {
    let label = family.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    
    // Handle special cases for display names
    if (family === '100-plus') label = '100 Plus';
    
    if (temperature === 'iced') {
      label += ' (Iced)';
    }
    
    return label;
  }
  
  // Handle kopi/teh drinks
  let labelParts = [family.charAt(0).toUpperCase() + family.slice(1)];
  
  // Add milk/black modifier
  if (milkOrBlack && milkOrBlack !== 'default') {
    labelParts.push(milkOrBlack.toUpperCase());
  }
  
  // Add sweetness modifier
  if (sweetness && sweetness !== 'default') {
    const sweetnessLabels = {
      'kosong': 'Kosong',
      'siew-dai': 'Siew Dai',
      'gah-dai': 'Gah Dai'
    };
    labelParts.push(sweetnessLabels[sweetness]);
  }
  
  // Add strength modifier
  if (strength && strength !== 'default') {
    const strengthLabels = {
      'gao': 'Gao',
      'po': 'Po',
      'di-lo': 'Di Lo'
    };
    labelParts.push(strengthLabels[strength]);
  }
  
  // Add special modifier
  if (special && special !== 'none') {
    const specialLabels = {
      'tarik': 'Tarik',
      'gu-you': 'Gu You',
      'halia': 'Halia'
    };
    labelParts.push(specialLabels[special]);
  }
  
  // Add temperature
  if (temperature === 'iced') {
    labelParts.push('Peng');
  }
  
  return labelParts.join(' ');
};